// extracted by mini-css-extract-plugin
export var deleteIcon = "_ow-5";
export var deleteOption = "_ow-3";
export var divider = "_ow-2";
export var downloadIcon = "_ow-4";
export var drawer = "_ow-0";
export var drawerFooter = "_ow-6";
export var drawerOpen = "_ow-1";
export var highlighted = "_ow-7";
export var lighterHighlight = "_ow-8";